import type { PageDataset } from "../api";
export function formatValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
export function DataTable({ dataset }: { dataset: PageDataset }) {
  const rows = dataset.rows.slice(0, 50);
  const columns = dataset.columns?.length
    ? dataset.columns
    : Array.from(
        new Set(
          rows.flatMap((row) =>
            row && typeof row === "object" && !Array.isArray(row) ? Object.keys(row as Record<string, unknown>) : ["value"]
          )
        )
      ).slice(0, 8);
  if (!rows.length) {
    return <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-6 text-sm text-slate-500">No rows available.</div>;
  }
  return (
    <div className="data-table-card">
      <div className="data-table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column}>{column.replaceAll("_", " ")}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {columns.map((column) => {
                  const value =
                    row && typeof row === "object" && !Array.isArray(row)
                      ? (row as Record<string, unknown>)[column]
                      : row;
                  return (
                    <td key={column}>{formatValue(value)}</td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
